import { render, staticRenderFns } from "./EnablingTypeCategoriesRegistryList.vue?vue&type=template&id=6d077d84"
import script from "./EnablingTypeCategoriesRegistryList.vue?vue&type=script&lang=js"
export * from "./EnablingTypeCategoriesRegistryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports